/**
 * Fetches all logs for a specific client.
 * 
 * Endpoint: GET https://95nf5mwr54.execute-api.ap-southeast-1.amazonaws.com/prod/getClientLogsById
 * Query Parameters: client_id
 * Response: Array of log objects with { log_id, client_id, log_data, user_update, timestamp_update }
 * 
 * @param {string} clientId - The ID of the client.
 * @returns {Promise<Array>} - An array of log objects.
 * @throws {Error} - If the network request fails or returns non-2xx.
 */
export async function getClientLogsById(clientId) {
  const url = `https://95nf5mwr54.execute-api.ap-southeast-1.amazonaws.com/prod/getClientLogsById?client_id=${encodeURIComponent(clientId)}`;

  try {
    const res = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: { 'Accept': 'application/json' },
    });
    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Status ${res.status}: ${text}`);
    }
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error('Error fetching client logs:', error);
    throw error;
  }
}

/**
 * Posts a new log entry for a client.
 * 
 * Endpoint: POST https://y4gdgw7g2a.execute-api.ap-southeast-1.amazonaws.com/prod/postClientLogs
 * Body: { client_id, log_data, user_update }
 * Response: { success: true, log_id: "...", timestamp_update: "..." }
 * 
 * @param {string} clientId - The ID of the client.
 * @param {string} logData - The log data/message.
 * @param {string} userUpdate - The username of the person creating the log.
 * @returns {Promise<Object>} - The response from the API.
 * @throws {Error} - If the network request fails.
 */
export async function postClientLogs(clientId, logData, userUpdate) {
  const url = 'https://y4gdgw7g2a.execute-api.ap-southeast-1.amazonaws.com/prod/postClientLogs';

  try {
    const res = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({
        client_id: clientId,
        log_data: logData,
        user_update: userUpdate,
      }),
    });
    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Status ${res.status}: ${text}`);
    }
    return res.json();
  } catch (error) {
    console.error('Error posting client log:', error);
    throw error;
  }
}
